import { render, staticRenderFns } from "./TestScanner.vue?vue&type=template&id=5435968b&scoped=true"
import script from "./TestScanner.vue?vue&type=script&lang=js"
export * from "./TestScanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5435968b",
  null
  
)

export default component.exports